import { useCallback } from "react";
import LayerSelector from "./LayerSelector";

/**
 * The Hydrographic Basins Map Layer Selector Component
 * @param {{
 *  "onSelect": () => void,
 *  "selected": boolean | null | undefined
 * }} props
 * @returns import("react").JSX.Element
 */
export default function HydroLayerSelector({ onSelect, selected }) {
  const handleSelect = useCallback(() => {
    onSelect();
  }, [onSelect]);

  return (
    <LayerSelector type="hydro" onSelect={handleSelect} selected={selected} />
  );
}
